import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { AdNetworksPieChartDto, AdNetworksRequestParams } from "../../../company/types/ad-networks";
import { accountOverviewQueryKeys } from "../queryKeyFactory";

type QueryOptions = {
    isEnabled?: boolean;
};

export default function useAdNetworksPieChartQuery(
    params: AdNetworksRequestParams,
    options: QueryOptions = {},
): UseQueryResult<AdNetworksPieChartDto> {
    const { isEnabled = true } = options;

    return useQuery({
        queryKey: accountOverviewQueryKeys.adNetworksPieChart(params),
        enabled: isEnabled && salesSettingsHelper.isSiAdNetworksFeatureEnabled,
        queryFn({ signal }) {
            return salesApiService.accountOverview.fetchAdNetworksPieChart(params, {
                cancellation: signal,
            });
        },
    });
}
